module.exports = __webpack_public_path__ + "static/media/image.4dbc1416.png";